module.exports = __webpack_public_path__ + "img/2026big14.3e9db078.png";